import React from "react";
import "../styles/Franquia.css";
import { MapPin, Laptop, UserCheck } from "lucide-react";
import heroImg from "../assets/franquia-image.svg"; 
import brasilMap from "../assets/brasil-map.svg"; 

const Franquia = () => {
  const handleRedirect = () => {
    window.location.href = "#contato-suporte";
  };

  return (
    <section className="franquia">
      {/* Topo da sessão */}
      <div className="franquia-top">
        <div className="franquia-text">
          <h2>Seja o Tact da sua cidade</h2>
          <p>
            O mercado imobiliário brasileiro vive uma nova era digital. 
            O <strong>Tact</strong> conecta dados, tecnologia e oportunidades 
            para transformar a maneira como cidades crescem e você pode 
            liderar essa transformação na sua região.
          </p>
          <button className="franquia-btn" onClick={handleRedirect}>
            Quero saber mais sobre a franquia
          </button>
        </div>

        <div className="franquia-img">
          <img src={heroImg} alt="Franquia Tact" />
        </div>
      </div>

      {/* Cards informativos */}
      <div className="franquia-cards">
        <div className="card">
          <MapPin size={36} color="#29306a" />
          <h3>Território exclusivo</h3>
          <p>
            Atue com exclusividade em sua região, fortalecendo sua presença local e garantindo 
            oportunidades únicas de expansão.
          </p>
        </div>
        <div className="card">
          <Laptop size={36} color="#29306a" />
          <h3>Plataforma e dados</h3>
          <p>
            Plataforma completa com dados estratégicos que impulsionam 
            decisões e aceleram resultados no mercado imobiliário.
          </p>
        </div>
        <div className="card">
          <UserCheck size={36} color="#29306a" />
          <h3>Onboarding e suporte</h3>
          <p>
            Receba treinamento completo, acompanhamento constante e suporte técnico 
            para garantir o sucesso da sua operação.
          </p>
        </div>
      </div>

      {/* Card maior inferior com dados do mercado */}
      <div className="franquia-detalhes">
        <div className="detalhes-text">
          <h3>Por que investir no mercado imobiliário com o Tact?</h3>
          <ul>
            <li>
              O setor imobiliário movimentou mais de <strong>R$ 250 bilhões</strong> no Brasil em 2024.
            </li>
            <li>
              O mercado cresceu cerca de <strong>9,8%</strong> em relação ao ano anterior,
              impulsionado pela digitalização e novos modelos de negócio.
            </li>
            <li>
              Mais de <strong>70%</strong> das imobiliárias buscam soluções baseadas em dados
              para otimizar suas vendas.
            </li>
            <li>
              O <strong>Tact</strong> oferece tecnologia de análise territorial exclusiva,
              transformando dados em decisões estratégicas.
            </li>
            <li>
              Com o modelo de franquia, você opera em um <strong>território exclusivo</strong>,
              com acesso total à nossa plataforma e suporte especializado.
            </li>
          </ul>

          <button className="franquia-btn-2" onClick={handleRedirect}>
            Quero saber mais sobre a franquia
          </button>
        </div>

        <div className="detalhes-img">
          <img src={brasilMap} alt="Mapa do Brasil" />
        </div>
      </div>
    </section>
  );
};

export default Franquia;
